/**
 * Phase 13 Metrics Dashboard — useDviLearningAlerts
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
// DTC-J: route the 14-day learning-alerts lookback window through the
// canonical clock so RPC query bounds are deterministic under
// `clock.setFixed(...)`.
import { clock } from '@/utils/clock';

export interface LearningAlert {
  occurred_at: string;
  event_type: 'confidence_jump' | 'regression' | 'threshold_change' | 'threshold_edit' | string;
  component: string;
  condition_type: string;
  detail: string;
  severity: 'info' | 'high' | string;
}

export function useDviLearningAlerts(shopId: string | null) {
  return useQuery({
    queryKey: ['dvi-learning-alerts', shopId],
    queryFn: async (): Promise<LearningAlert[]> => {
      const since = new Date(clock.nowMs() - 14 * 24 * 60 * 60 * 1000).toISOString();
      const { data, error } = await supabase.rpc('get_dvi_learning_alerts', {
        p_shop_id: shopId,
        p_since: since,
      });
      if (error) throw error;
      return (data ?? []) as LearningAlert[];
    },
    enabled: !!shopId,
    refetchInterval: 30 * 1000,
    staleTime: 20 * 1000,
  });
}
